dmx.Formatters('boolean', {

    // then(trueValue:Any, falseValue:Any):Any
    then: function(bool, trueValue, falseValue) {
        return bool ? trueValue : falseValue;
    }

});
